// plugins/chatProvider.js
export default ({ app }, inject) => {
  const provider = process.env.CHAT_PROVIDER;

  const chat = {
    hideChat() {
      if (process.client) {
        if (provider === 'crisp' && window.$crisp) {
          window.$crisp.push(["do", "chat:hide"]);
        }
        if (provider === 'chatwoot' && window.$chatwoot) {
          window.$chatwoot.toggle("close");
        }
      }
    },
    showChat() {
      if (process.client) {
        if (provider === 'crisp' && window.$crisp) {
          window.$crisp.push(["do", "chat:show"]);
        }
        if (provider === 'chatwoot' && window.$chatwoot) {
          window.$chatwoot.toggle("open");
        }
      }
    },
    toggleBubbleVisibility(hideShow) {
      if (process.client) {
        if (provider === 'chatwoot') {
          window.addEventListener('chatwoot:ready', () => {
            window.$chatwoot?.toggleBubbleVisibility(hideShow);
          });

          if (window.$chatwoot) {
            window.$chatwoot?.toggleBubbleVisibility(hideShow);
          }
        }

        if (provider === 'crisp' && window.$crisp) {
          window.$crisp.push(["do", `chat:${hideShow}`]);
        }
      }
    }
  };

  inject('chat', chat); // Puedes acceder luego con this.$chat
};
